var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-text',{staticClass:"text-center mx-auto"},[_c('div',{staticClass:"primary--text text--darken-4 text-h5"},[_vm._v("พบปัญหาการใช้งานติดต่อ")]),_c('div',{staticClass:"secondary--text text-title-3"},[_vm._v("Line @vwell")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }